export const PATH_NAMES = {
    CONTENT_OVERVIEW: 'content',
    CONTENT_LIVE: 'live'
}